import { RevisionPlanRow } from 'components/tables/data/revision-plan/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the remote source name.
 */
export default function RemoteSourceColumn({ data: { remoteSource } }: { data: RevisionPlanRow }) {
  if (!remoteSource) {
    return null;
  }

  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {remoteSource.name}
    </P2Regular>
  );
}
